import React from 'react';

/** The few glyphs the shared components need. All decorative. */
const svg = (children: React.ReactNode, className?: string) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    aria-hidden="true"
  >
    {children}
  </svg>
);

export const CloseIcon: React.FC = () => svg(<path d="M4 4l8 8M12 4l-8 8" />);
export const CloseSmallIcon: React.FC = () => svg(<path d="M5 5l6 6M11 5l-6 6" />);
export const ChevronDownIcon: React.FC<{ className?: string }> = ({ className }) =>
  svg(<path d="M4 6l4 4 4-4" />, className);
export const SearchIcon: React.FC = () =>
  svg(
    <>
      <circle cx="7" cy="7" r="4.5" />
      <path d="M10.5 10.5L14 14" />
    </>,
  );
export const MoreIcon: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
    <circle cx="3" cy="8" r="1.5" />
    <circle cx="8" cy="8" r="1.5" />
    <circle cx="13" cy="8" r="1.5" />
  </svg>
);
